import { render, staticRenderFns } from "./SearchProductLotsDetailPage.vue?vue&type=template&id=31070006&"
import script from "./SearchProductLotsDetailPage.vue?vue&type=script&lang=js&"
export * from "./SearchProductLotsDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports